var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 28.5C52.5 33.3456 51.0631 38.0825 48.371 42.1115C45.6789 46.1405 41.8525 49.2807 37.3757 51.135C32.899 52.9894 27.9728 53.4746 23.2203 52.5292C18.4678 51.5839 14.1023 49.2505 10.6759 45.8241C7.2495 42.3977 4.9161 38.0322 3.97076 33.2797C3.02542 28.5272 3.5106 23.601 5.36495 19.1243C7.2193 14.6475 10.3595 10.8211 14.3885 8.12899C18.4175 5.4369 23.1544 4 28 4",
    stroke: "white",
    strokeWidth: 6.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/LoadingIcon.4271f6755833baf6b124ecf0a283c439.svg";
export { ForwardRef as ReactComponent };